import script from "./BodyTopMain.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyTopMain.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyTopMain.vue?vue&type=style&index=0&id=038c4d14&module=bodyTopMain&lang=css"
cssModules["bodyTopMain"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__